import React, { useState } from 'react';

/**
 * Modal para pausar execução de teste, coletando motivo opcional.
 */
const PauseExecutionModal = ({ isOpen, onClose, onConfirm, execution }) => {
  const [reason, setReason] = useState('');
  if (!isOpen) return null;

  const label = execution?.name ? `${execution.name}` : 'Execução';
  const idLabel = execution?.id ? ` (ID: ${execution.id})` : '';

  const confirm = () => {
    onConfirm(reason.trim());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Pausar execução</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p>
            Deseja pausar a execução <strong>{label}</strong>{idLabel}?
          </p>
          <div className="form-group" style={{ marginTop: 12 }}>
            <label>Motivo (opcional)</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Descreva rapidamente o motivo da pausa"
              rows={3}
              maxLength={500}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-warning" onClick={confirm}>⏸️ Pausar</button>
        </div>
      </div>
    </div>
  );
};

export default PauseExecutionModal;